import { Component, enableProdMode } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SuEnvService } from './shared/services/env.service';
import { Languages } from '@seahorse/common';

@Component({
  selector: 'su-root',
  templateUrl: './super-user-app.component.html',
  standalone: false,
})
export class SuperUserAppComponent {
  theme: string;

  constructor(translate: TranslateService, environment: SuEnvService) {
    if (!environment.enableDebug) {
      enableProdMode();
    }

    // Step 12: a user without a saved language preference gets the browser's
    // language when the app has it, else English. English is also the
    // fallback for keys missing in nl / sr. A saved preference still wins:
    // the preloader applies it after login.
    const supported = Languages.map((language) => language.value);
    translate.addLangs(supported);
    translate.setDefaultLang('en');
    const browserLang = translate.getBrowserLang();
    translate.use(
      browserLang && supported.includes(browserLang) ? browserLang : 'en'
    );

    this.theme = environment.theme;
    const bodies = document.getElementsByTagName('body');
    for (let i = 0; i < bodies.length; i++) {
      bodies[i].setAttribute('apptheme', this.theme);
    }
  }
}
